export default "__VITE_ASSET__CNWjXPNR__"